import { Box, Typography } from "@mui/material"
import { makeStyles } from "tss-react/mui"
import { DateTime } from "luxon"
import { WeekMenuProduct } from "../../../../weekMenuTypes"
import { Stack } from "@mui/system"
import { useDateTime } from "../../../../../../../localization/useDateTime"

const useStyles = makeStyles()((theme) => ({
    daySelector: {
        display: "flex",
        gap: "0.5rem",
        marginBottom: "1.5rem",
        overflowX: "auto",
        paddingBottom: "0.25rem",
        "&::-webkit-scrollbar": {
            display: "none",
        },
    },
    dayButtonDisabled: {
        opacity: 0.4,
        cursor: "not-allowed",
    },
    dayButton: {
        minWidth: "3.75rem",
        padding: "0.75rem 1rem",
        borderRadius: "1.5rem",
        border: "none",
        backgroundColor: theme.palette.tailwind.slate[200],
        cursor: "pointer",
        transition: "all 0.2s ease",
        alignItems: "center",
        gap: "0.25rem",
        "&:hover:not(:disabled)": {
            backgroundColor: theme.palette.tailwind.slate[300],
        },
        "&.active, &:hover.active": {
            backgroundColor: theme.palette.tailwind.slate[800],
            color: "white",
        },
    },
    dayNumber: {
        fontSize: "1.125rem",
        fontWeight: 600,
        lineHeight: 1,
    },
    dayName: {
        fontSize: "0.75rem",
        fontWeight: 400,
        lineHeight: 1,
    },
}))

interface DaySelectorProps {
    weekMenus: Array<{
        date: string
        products: WeekMenuProduct[]
    }>
    currentIndex: number
    onDaySelect: (index: number) => void
}

export const DaySelector = ({ weekMenus, currentIndex, onDaySelect }: DaySelectorProps) => {
    const { classes, cx } = useStyles()
    const dateTimeFactory = useDateTime()

    return (
        <Box className={classes.daySelector}>
            {weekMenus.map((menu, index) => {
                const date = dateTimeFactory.fromISO(menu.date)
                const hasMenuItems = menu.products?.length > 0
                const isActive = index === currentIndex

                return (
                    <Stack
                        key={menu.date}
                        className={cx(
                            classes.dayButton,
                            isActive && "active",
                            !hasMenuItems && classes.dayButtonDisabled,
                        )}
                        onClick={() => hasMenuItems && onDaySelect(index)}
                    >
                        <Typography className={classes.dayNumber}>{date.day}</Typography>
                        <Typography className={classes.dayName}>{date.toFormat("EEE")}</Typography>
                    </Stack>
                )
            })}
        </Box>
    )
}
